import {TissotRhfEditor} from './tissot-rhf-editor';
import {TissotRhfSelect} from './tissot-rhf-select';

export const TissotField = {
  Select: TissotRhfSelect,
  Editor: TissotRhfEditor,
};
